// import React from "react";

// const destinations = [
//   {
//     id: 1,
//     name: "Mumbai",
//     image: "/images/network/mumbai.jpg",
//   },
//   {
//     id: 2,
//     name: "Lonavala",
//     image: "/images/network/lonavla.jpg",
//   },
//   {
//     id: 3,
//     name: "Mahabaleshwar",
//     image: "/images/network/mahabaleshwar.jpg",
//   },
//   {
//     id: 4,
//     name: "Shirdi",
//     image: "/images/network/shirdi.jpg",
//   },
//   {
//     id: 5,
//     name: "Nashik",
//     image: "/images/network/nashik.jpg",
//   },
//   {
//     id: 6,
//     name: "Kolhapur",
//     image: "/images/network/kolhapur.jpg",
//   },
//   {
//     id: 7,
//     name: "Goa",
//     image: "/images/network/goa.jpg",
//   },
//   {
//     id: 8,
//     name: "Ratnagiri",
//     image: "/images/network/ratnagiri.jpg",
//   },
//   {
//     id: 9,
//     name: "Lavasa",
//     image: "/images/network/lavasa.jpg",
//   },
//   {
//     id: 10,
//     name: "Alibag",
//     image: "/images/network/alibag.jpg",
//   },
//   {
//     id: 11,
//     name: "Satara",
//     image: "/images/network/satara.jpg",
//   },
//   {
//     id: 12,
//     name: "Aurangabad",
//     image: "/images/network/aurangabad.jpg",
//   },
// ];

// const OurNetwork = () => {
//   return (





// <>



  // <div className="breadcrumb-bar text-center">
  //       <h2 className="text-white">Our Network</h2>
  //     </div>


//     <section className="network-section">
//       <div className="container">
        
      
      
//         <div className="row">
//           {destinations.map((place) => (
//             <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={place.id}>
//               <div className="network-card">
//                 <img src={place.image} alt={place.name} />
                
//                 <div className="network-overlay">
//                   <h3>{place.name}</h3>
//                   {/* <button>Book Now</button> */}
//                 </div>

//               </div>
//             </div>
//           ))}
//         </div>

//       </div>
//     </section>
// </>
//   );
// };

// export default OurNetwork;













import React, { useState } from "react";

const destinations = [
  { id: 1, name: "Mumbai", image: "/images/network/mumbai.jpg" },
  { id: 2, name: "Lonavala", image: "/images/network/lonavla.jpg" },
  { id: 3, name: "Mahabaleshwar", image: "/images/network/mahabaleshwar.jpg" },
  { id: 4, name: "Shirdi", image: "/images/network/shirdi.jpg" },
  { id: 5, name: "Nashik", image: "/images/network/nashik.jpg" },
  { id: 6, name: "Kolhapur", image: "/images/network/kolhapur.jpg" },
  { id: 7, name: "Goa", image: "/images/network/goa.jpg" },
  { id: 8, name: "Ratnagiri", image: "/images/network/ratnagiri.jpg" },
  { id: 9, name: "Lavasa", image: "/images/network/lavasa.jpg" },
  { id: 10, name: "Alibag", image: "/images/network/alibag.jpg" },
  { id: 11, name: "Satara", image: "/images/network/satara.jpg" },
  { id: 12, name: "Aurangabad", image: "/images/network/aurangabad.jpg" },
];

const OurNetwork = () => {
  const [active, setActive] = useState(destinations[0]);

  return (
    <>
      {/* BREADCRUMB */}
       <div className="breadcrumb-bar text-center">
        <h2 className="text-white">Our Network</h2>
      </div>

      {/* MAIN SECTION */}
      <div className="network-wrapper">
        <div className="network-container">

          {/* LEFT SIDE CITY LIST */}
          <div className="network-sidebar">
            {destinations.map((city) => (
              <div
                key={city.id}
                className={`city-item ${active.id === city.id ? "active" : ""}`}
                onClick={() => setActive(city)}
              >
                {city.name}
              </div>
            ))}
          </div>

          {/* RIGHT SIDE DETAILS */}
          <div className="network-content">
            <div className="image-box">
              <img src={active.image} alt={active.name} />
            </div>

            <div className="info-box">
              <h2>{active.name}</h2>
              <p>
                Premium cab service available for <b>{active.name}</b>.
                Comfortable rides, professional drivers, and best pricing for
                outstation travel with Shivai Travels.
              </p>

              <button>Book {active.name} Trip</button>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default OurNetwork;